(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-aankondiging"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = (el) => {
      if (el.dataset.rhKlaar) return;
      el.dataset.rhKlaar = '1';
      const berichten = [...el.querySelectorAll('.rh-aank__bericht')];
      const knop = el.querySelector('[data-rh-aank-knop]');
      if (berichten.length < 2) return;
      const ms = (Number(el.dataset.seconden) || 5) * 1000;
      const rustig = matchMedia('(prefers-reduced-motion: reduce)');
      let i = 0;
      let gepauzeerd = rustig.matches;
      let vast = false;
      let timer = null;

      const toon = (n) => {
        berichten.forEach((b, k) => {
          const actief = k === n;
          b.classList.toggle('is-actief', actief);
          b.toggleAttribute('aria-hidden', !actief);
          b.querySelectorAll('a').forEach((a) => (actief ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
      };
      const volgende = () => {
        i = (i + 1) % berichten.length;
        toon(i);
      };
      const plan = () => {
        clearInterval(timer);
        if (!gepauzeerd && !vast) timer = setInterval(volgende, ms);
      };
      const zetKnop = () => {
        if (!knop) return;
        knop.setAttribute('aria-pressed', String(gepauzeerd));
        knop.setAttribute('aria-label', gepauzeerd ? 'Berichten afspelen' : 'Berichten pauzeren');
      };

      knop?.addEventListener('click', () => {
        gepauzeerd = !gepauzeerd;
        zetKnop();
        plan();
      });
      el.addEventListener('mouseenter', () => { vast = true; plan(); });
      el.addEventListener('mouseleave', () => { vast = false; plan(); });
      el.addEventListener('focusin', () => { vast = true; plan(); });
      el.addEventListener('focusout', () => { vast = false; plan(); });
      zetKnop();
      plan();
    };

    const alles = () => document.querySelectorAll('[data-rh-aank]').forEach(start);
    alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-collectie"]) return;
  try {
    
  (() => {
    const start = (el) => {
      if (el.dataset.rhKlaar) return;
      el.dataset.rhKlaar = '1';
      const raster = el.querySelector('[data-rh-raster]');
      const knoppen = el.querySelectorAll('[data-rh-kolommen]');
      const zet = (stand) => {
        if (!raster) return;
        raster.dataset.kolommen = stand;
        knoppen.forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.rhKolommen === stand)));
        try { localStorage.setItem('rh-kolommen', stand); } catch {}
      };
      let bewaard = 'groot';
      try { bewaard = localStorage.getItem('rh-kolommen') || 'groot'; } catch {}
      zet(bewaard);
      knoppen.forEach((k) => k.addEventListener('click', () => zet(k.dataset.rhKolommen)));

      // Meer laden: volgende pagina ophalen en de kaarten erachter zetten. Zonder JS is het een link.
      el.addEventListener('click', async (e) => {
        const knop = e.target.closest?.('[data-rh-meer]');
        if (!knop || !raster) return;
        e.preventDefault();
        knop.setAttribute('aria-busy', 'true');
        try {
          const html = await (await fetch(knop.href)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-rh-raster] > *').forEach((k) => raster.appendChild(k));
          const volgende = doc.querySelector('[data-rh-meer]');
          if (volgende) {
            knop.href = volgende.href;
            knop.removeAttribute('aria-busy');
          } else {
            knop.closest('.rh-col__meer')?.remove();
          }
        } catch {
          location.href = knop.href;
        }
      });

      // Sorteerlijst sluiten bij klik ernaast of Escape.
      const sorteer = el.querySelector('.rh-sorteer');
      document.addEventListener('click', (e) => { if (sorteer?.open && !sorteer.contains(e.target)) sorteer.open = false; });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sorteer?.open) sorteer.open = false; });
    };
    const alles = () => document.querySelectorAll('[data-rh-collectie]').forEach(start);
    alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Zet een bolletje bij de categorie die in beeld is (Rhode). Zonder IntersectionObserver
    // blijven het gewone ankerlinks.
    const start = (el) => {
      if (el.dataset.rhKlaar) return;
      el.dataset.rhKlaar = '1';
      const links = [...el.querySelectorAll('[data-rh-faq-link]')];
      if (!links.length || !('IntersectionObserver' in window)) return;
      const zet = (id) =>
        links.forEach((a) => {
          if (a.dataset.rhFaqLink === id) a.setAttribute('aria-current', 'location');
          else a.removeAttribute('aria-current');
        });
      const io = new IntersectionObserver(
        (items) => items.forEach((i) => i.isIntersecting && zet(i.target.id)),
        { rootMargin: '-25% 0px -65% 0px' }
      );
      el.querySelectorAll('[data-rh-faq-cat]').forEach((c) => io.observe(c));
    };
    const alles = () => document.querySelectorAll('[data-rh-faq]').forEach(start);
    alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const start = (el) => {
      if (el.dataset.rhKlaar) return;
      el.dataset.rhKlaar = '1';
      const knoppen = [...el.querySelectorAll('[data-rh-tab]')];
      const kies = (knop, focus) => {
        const n = knop.dataset.rhTab;
        knoppen.forEach((k) => {
          const aan = k === knop;
          k.setAttribute('aria-selected', String(aan));
          k.tabIndex = aan ? 0 : -1;
          document.getElementById(k.getAttribute('aria-controls')).hidden = !aan;
        });
        el.querySelectorAll('[data-rh-foto]').forEach((f) => (f.hidden = f.dataset.rhFoto !== n));
        if (focus) knop.focus();
      };
      knoppen.forEach((k, i) => {
        k.addEventListener('click', () => kies(k));
        k.addEventListener('keydown', (e) => {
          const stap = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
          if (!stap) return;
          e.preventDefault();
          kies(knoppen[(i + stap + knoppen.length) % knoppen.length], true);
        });
      });
    };
    const alles = () => document.querySelectorAll('[data-rh-tabs]').forEach(start);
    alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-volgen"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SCRIPT = 'https://www.17track.net/externalcall.js';
    let laden = null;
    const laad = () =>
      (laden ??= new Promise((ok, fout) => {
        if (window.YQV5) return ok();
        const s = document.createElement('script');
        s.src = SCRIPT;
        s.async = true;
        s.onload = ok;
        s.onerror = () => {
          laden = null;
          fout(new Error('17TRACK niet bereikbaar'));
        };
        document.head.appendChild(s);
      }));

    const start = (el) => {
      if (el.dataset.rhKlaar) return;
      el.dataset.rhKlaar = '1';
      const form = el.querySelector('[data-rh-volg-form]');
      const veld = el.querySelector('[data-rh-volg-nummer]');
      const fout = el.querySelector('[data-rh-volg-fout]');
      const uitslag = el.querySelector('[data-rh-volg-uitslag]');
      const doos = el.querySelector('[data-rh-volg-doos]');
      const opnieuw = el.querySelector('[data-rh-volg-opnieuw]');
      if (!form || !veld || !uitslag || !doos) return;
      const rustig = matchMedia('(prefers-reduced-motion: reduce)');

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const nummer = veld.value.replace(/\s+/g, '').toUpperCase();
        if (!nummer) {
          fout.hidden = false;
          veld.setAttribute('aria-invalid', 'true');
          veld.focus();
          return;
        }
        fout.hidden = true;
        veld.removeAttribute('aria-invalid');
        form.hidden = true;
        uitslag.hidden = false;
        doos.textContent = 'De status wordt geladen…';
        uitslag.scrollIntoView({ behavior: rustig.matches ? 'auto' : 'smooth', block: 'start' });
        try {
          await laad();
          doos.textContent = '';
          window.YQV5.trackSingle({ YQ_ContainerId: doos.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'nl', YQ_Num: nummer });
        } catch {
          doos.textContent =
            'De live status kon niet worden geladen. Probeer het zo nog eens, of volg je pakket via de link in de verzendmail.';
        }
      });

      opnieuw?.addEventListener('click', () => {
        uitslag.hidden = true;
        form.hidden = false;
        doos.textContent = '';
        veld.value = '';
        veld.focus();
      });
    };

    const alles = () => document.querySelectorAll('[data-rh-volgen]').forEach(start);
    alles();
    document.addEventListener('shopify:section:load', alles);
  })();

  } catch(e) { console.error(e); }
})();
})();
